/**
 * Search Drawer – mobile offcanvas search panel
 */
(function () {
  const drawer = document.getElementById('SearchDrawer');
  const overlay = document.getElementById('SearchDrawerOverlay');
  if (!drawer || !overlay) return;

  const input = drawer.querySelector('.search-drawer__input');
  const clearBtn = drawer.querySelector('.search-drawer__clear-btn');
  const closeBtn = drawer.querySelector('.search-drawer__close');
  const inputWrap = drawer.querySelector('.search-drawer__input-wrap');
  const defaultContent = drawer.querySelector('.search-drawer__default-content');
  const suggestionsWrap = drawer.querySelector('.search-drawer__suggestions');
  const suggestionsScroll = drawer.querySelector('.search-drawer__suggestions-scroll');
  const resultsWrap = drawer.querySelector('.search-drawer__results');
  const resultsList = drawer.querySelector('.search-drawer__results-list');
  const loadingEl = drawer.querySelector('.search-drawer__loading');
  const form = drawer.querySelector('.search-drawer__form');

  let abortController = null;
  let debounceTimer = null;
  const cache = {};

  /* ── Open / Close ────────────────────────────────── */
  function open() {
    drawer.classList.add('is-open');
    overlay.classList.add('is-open');
    document.body.classList.add('overflow-hidden');
    setTimeout(() => input && input.focus(), 350);
  }

  function close() {
    drawer.classList.remove('is-open');
    overlay.classList.remove('is-open');
    document.body.classList.remove('overflow-hidden');
  }

  // Expose globally so header-search summary can call it
  window.openSearchDrawer = open;

  closeBtn.addEventListener('click', close);
  overlay.addEventListener('click', close);

  // Hijack every <details-modal class="header__search"> so that on mobile
  // its open() redirects to the search drawer instead of the overlay modal.
  document.querySelectorAll('details-modal.header__search').forEach(function (modal) {
    var nativeOpen = modal.open.bind(modal);
    modal.open = function (event) {
      // Prevent the details element from opening
      if (event && event.target) {
        var det = event.target.closest('details');
        if (det) det.removeAttribute('open');
      }
      open();            // open the search drawer
    };
  });

  // Escape key
  drawer.addEventListener('keyup', function (e) {
    if (e.key === 'Escape') close();
  });

  /* ── Input handling ──────────────────────────────── */
  input.addEventListener('input', function () {
    const val = input.value.trim();
    inputWrap.classList.toggle('has-value', val.length > 0);

    clearTimeout(debounceTimer);
    if (!val.length) {
      showDefault();
      return;
    }
    debounceTimer = setTimeout(() => fetchResults(val), 300);
  });

  clearBtn.addEventListener('click', function () {
    input.value = '';
    inputWrap.classList.remove('has-value');
    showDefault();
    input.focus();
  });

  form.addEventListener('submit', function (e) {
    if (!input.value.trim().length) e.preventDefault();
  });

  /* ── Show/hide states ────────────────────────────── */
  function showDefault() {
    if (abortController) abortController.abort();
    defaultContent.classList.remove('is-hidden');
    suggestionsWrap.classList.remove('is-visible');
    resultsWrap.classList.remove('is-visible');
    loadingEl.classList.remove('is-visible');
  }

  function showSearchState() {
    defaultContent.classList.add('is-hidden');
    resultsWrap.classList.add('is-visible');
  }

  /* ── Fetch predictive search results ─────────────── */
  function fetchResults(term) {
    const key = term.toLowerCase().replace(/\s+/g, '-');
    if (cache[key]) {
      renderResults(cache[key], term);
      return;
    }

    if (abortController) abortController.abort();
    abortController = new AbortController();

    loadingEl.classList.add('is-visible');
    defaultContent.classList.add('is-hidden');

    fetch(
      window.routes.predictive_search_url +
        '?q=' + encodeURIComponent(term) +
        '&resources[type]=product,query&resources[limit]=10&section_id=predictive-search',
      { signal: abortController.signal }
    )
      .then(function (r) {
        if (!r.ok) throw new Error(r.status);
        return r.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var data = parseSection(doc);
        cache[key] = data;
        renderResults(data, term);
      })
      .catch(function (err) {
        if (err.name === 'AbortError') return;
        loadingEl.classList.remove('is-visible');
      });
  }

  /* ── Parse the predictive-search section HTML ────── */
  function parseSection(doc) {
    var queries = [];
    var products = [];

    // Suggestion queries
    doc.querySelectorAll('#predictive-search-results-queries-list li a').forEach(function (a) {
      queries.push({ text: a.textContent.trim(), url: a.href });
    });

    // Products
    doc.querySelectorAll('#predictive-search-results-products-list li').forEach(function (li) {
      var a = li.querySelector('a');
      var img = li.querySelector('img');
      var title = li.querySelector('.predictive-search__item-heading');
      var priceEl = li.querySelector('.price-item--sale') || li.querySelector('.price-item--regular') || li.querySelector('.price-item');
      products.push({
        url: a ? a.href : '#',
        image: img ? img.src : '',
        imageAlt: img ? img.alt : '',
        title: title ? title.textContent.trim() : '',
        price: priceEl ? priceEl.textContent.trim() : '',
      });
    });

    return { queries: queries, products: products };
  }

  /* ── Render results into drawer ──────────────────── */
  function renderResults(data, term) {
    loadingEl.classList.remove('is-visible');
    showSearchState();

    // Suggestions
    if (data.queries && data.queries.length) {
      suggestionsScroll.innerHTML = data.queries
        .map(function (q) {
          return '<a href="' + q.url + '" class="search-drawer__suggestion-chip">' + escapeHtml(q.text) + '</a>';
        })
        .join('');
      suggestionsWrap.classList.add('is-visible');
    } else {
      suggestionsWrap.classList.remove('is-visible');
    }

    // Products
    if (data.products && data.products.length) {
      resultsList.innerHTML = data.products
        .map(function (p) {
          return (
            '<li class="search-drawer__result-item">' +
            '<a href="' + p.url + '" class="search-drawer__result-link">' +
            (p.image
              ? '<img class="search-drawer__result-img" src="' + p.image + '" alt="' + escapeHtml(p.imageAlt) + '" loading="lazy" width="64" height="64">'
              : '') +
            '<div class="search-drawer__result-info">' +
            '<p class="search-drawer__result-name">' + escapeHtml(p.title) + '</p>' +
            '<p class="search-drawer__result-price">' + p.price + '</p>' +
            '</div></a></li>'
          );
        })
        .join('');
      resultsWrap.classList.add('is-visible');
    } else {
      resultsList.innerHTML = '<li class="search-drawer__result-item"><p style="color:#999;font-size:1.3rem;">No results found for "' + escapeHtml(term) + '"</p></li>';
      resultsWrap.classList.add('is-visible');
    }
  }

  function escapeHtml(str) {
    var d = document.createElement('div');
    d.textContent = str;
    return d.innerHTML;
  }
})();
